/* GAP configurator add-on, loaded by the Custom Liquid section in templates/page.gap-configurator.json. Trust line under
   the Add to cart button: when the order is dispatched, delivery cost and why to trust us. Facts come from the store's
   shipping and refund policies (free UK delivery from £100, Royal Mail, Maidstone studio, damaged items replaced or
   refunded). Production time: prints and foamboard 1-2 working days, everything else 3-5; the date shown uses the
   longer end, counted in UK working days (weekends and England bank holidays skipped). */
(function () {
  var FAST = /fine\s*art|photo|foam/i, FAST_DAYS = 2, SLOW_DAYS = 5, FREE_FROM = 100;
  var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29', '2028-08-28', '2028-12-25', '2028-12-26'];
  function q(s) { return document.querySelector(s); }
  function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function londonToday() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date())
        .forEach(function (x) { p[x.type] = +x.value; });
      return new Date(p.year, p.month - 1, p.day);
    } catch (e) { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
  }
  function addWorkdays(d, n) {
    d = new Date(d);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6 && HOLIDAYS.indexOf(ymd(d)) < 0) n--;
    }
    return d;
  }
  function fmt(d) {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()] + ' ' + d.getDate() + ' '
      + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()];
  }
  function run() {
    var dock = q('[data-gapcfg] [data-dock]'), cta = q('[data-gapcfg] .gapcfg__cta');
    if (!dock || !cta) return;
    var el = dock.querySelector('.gapcfg__trust');
    if (!el) { el = document.createElement('div'); el.className = 'gapcfg__trust'; }
    if (el.previousElementSibling !== cta) cta.insertAdjacentElement('afterend', el);
    var title = (q('[data-gapcfg] [data-title]') || {}).textContent || '';
    var price = parseFloat(((q('[data-gapcfg] [data-price]') || {}).textContent || '').replace(/[^0-9.]/g, '')) || 0;
    var days = FAST.test(title) ? FAST_DAYS : SLOW_DAYS;
    var html = '<span>Dispatched by <b>' + fmt(addWorkdays(londonToday(), days)) + '</b></span>'
      + '<span>' + (price >= FREE_FROM ? '<b>Free UK delivery</b>' : 'Free delivery over £' + FREE_FROM) + '</span>'
      + '<span>Printed in Maidstone</span><span>Damaged? We replace it</span>';
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  /* Product picker thumbnails (Framed / Dibond / Canvas / Fine art): clean renders that look like what the configurator makes.
     They replace the old product photos set in gap-poster.js (.gapp-pick__ic) and the picker cards (.gapcfg__pcard). */
  var TB = 'https://cdn.shopify.com/s/files/1/0901/8241/8812/files/';
  var tcss = document.createElement('style');
  tcss.textContent = '.gapp-pick__ic.f{background-image:url(' + TB + 'gap-thumb-framed.jpg?width=300)!important}'
    + '.gapp-pick__ic.d{background-image:url(' + TB + 'gap-thumb-dibond.jpg?width=300)!important}'
    + '.gapp-pick__ic.c{background-image:url(' + TB + 'gap-thumb-canvas.jpg?width=300)!important}'
    + '.gapp-pick__ic.a{background-image:url(' + TB + 'gap-thumb-fineart.jpg?width=300)!important}';
  document.head.appendChild(tcss);
  var css = document.createElement('style');
  css.textContent = '.gapcfg__trust{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:2px 8px;padding:2px 16px calc(8px + env(safe-area-inset-bottom));font-size:11px;line-height:1.3;color:#4A4540}'
    + '.gapcfg__trust span{min-width:0}'
    + '.gapcfg__trust span:before{content:"\\2713";color:#2E7D32;font-weight:700;margin-right:5px}'
    + '.gapcfg__trust b{font-weight:700;color:#1E1B18}'
    + '.gapcfg__cta+.gapcfg__trust{margin-top:-6px}'
    + 'html.gapcfg-kb .gapcfg__trust{display:none}@media (max-width:899px){[data-gapcfg].is-sheet .gapcfg__trust{display:none}}'
    /* narrow phones (320 px): smaller dock text so the dock stays short and the status line and Rotate sit clear of the frame */
    + '@media (max-width:359px){[data-gapcfg] .gapcfg__summary{font-size:11px;line-height:1.25;letter-spacing:0;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;min-width:0}'
    + '[data-gapcfg] .gapcfg__status{font-size:12px;line-height:1.3;margin-top:6px}.gapcfg__trust{font-size:10px;letter-spacing:0;gap:1px 6px}}';
  document.head.appendChild(css);
  function start() {
    var g = q('[data-gapcfg]');
    if (!g) return false;
    new MutationObserver(run).observe(g, { childList: true, subtree: true, characterData: true });
    run();
    return true;
  }
  if (!start()) document.addEventListener('DOMContentLoaded', start);
})();
